export default [
  {
    path: '/scene',
    component: () => import('@/views/modules/scene/show'),
    name: 'Scene',
    meta: {
      title: '商品场景化',
      isTab: false
    }
  },
  {
    path: '/scene-list',
    component: () => import('@/views/modules/scene/list'),
    name: 'SceneList',
    meta: {
      title: '场景化商品列表',
      isTab: false
    }
  }
]
